import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useQueryClient } from "react-query";
import { Loader } from "@egovernments/digit-ui-react-components";
import { useHistory , useParams} from "react-router-dom";
import { OBPSService } from '../../../libraries/src/services/elements/OBPS'
import ApplicationDetailsContentForm12 from "./components/ApplicationDetailsContentForm12";
import { Button, Card, Dialog, DialogActions, DialogContentText, DialogTitle } from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import DialogContent from "@mui/material/DialogContent";


const ApplicationDetailsForm12 = (props) => {
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const state = Digit.ULBService.getStateId();
  const userInfo = Digit.UserService.getUser()?.info || {};
  let user = Digit.UserService.getUser();
  const userRolesArray = userInfo?.roles.filter((user) => user.code !== "EMPLOYEE");
  const { t } = useTranslation();
  const history = useHistory();
  let { id: applicationNumber } = useParams();
  const [selectedAction, setSelectedAction] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [isEnableLoader, setIsEnableLoader] = useState(false);
  const [isWarningPop, setWarningPopUp] = useState(false);
  const [onAddComments, setOnAddComments] = useState("");
  const [opendata, setOpenData] = useState(false);

  const {
    applicationDetails,
    showToast,
    setShowToast,
    isLoading,
    isDataLoading,
    applicationData,
    edcrDetails,
    collectionBillDetails,
    mutate,
    nocMutation,
    workflowDetails,
    businessService,
    closeToast,
    moduleCode,
    timelineStatusPrefix,
    forcedActionPrefix,
    statusAttribute,
    paymentsList,
    showTimeLine = true,
  } = props;
           
  useEffect(() => {
    if (showToast) {
      workflowDetails.revalidate();
    }
  }, [showToast]);
 
  async function onActionSelect(action) {
    console.log("9999999999999",action);
    if (action) {
      if (action?.isWarningPopUp) {
        setShowModal(false)
      }
      else if (action?.redirectionUrll) {
        window.location.assign(`${window.location.origin}/digit-ui/employee/payment/collect/${action?.redirectionUrll?.pathname}`);
      }
      else if (action === 'ISSUE_CERTIFICATE') {
        console.log("yes",action);
        setShowModal(false)
        let payload = {}
        payload.BPA = applicationData
        payload.BPA.workflow = {
          "action": "ISSUE_CERTIFICATE",
          "assignes": null,
          "comments": onAddComments,
          "varificationDocuments": null
        },
          payload.RequestInfo = applicationDetails?.RequestInfo
        //update call
        try {
          const res = await OBPSService.designOfApprovalLetterPdf(state, applicationDetails?.applicationNo);
          const pdfBlob = new Blob([res?.data], { type: "application/pdf" });
          const pdfUrl = URL.createObjectURL(pdfBlob);
          window.open(pdfUrl);
        } catch (error) {
          console.error("Error in ISSUE_CERTIFICATE action:", error);
        }
      }
    
      else if (!action?.redirectionUrl) {
        setShowModal(true);
      }
      else {
        history.push({
          pathname: action.redirectionUrl?.pathname,
          state: { ...action.redirectionUrl?.state },
        });
      }
    }
    setSelectedAction(action);
    setDisplayMenu(false);
  }
  const queryClient = useQueryClient();
  const closeModal = () => {
    setSelectedAction(null);
    setShowModal(false);
  };
  const closeWarningPopup = () => {
    setWarningPopUp(false);
  }

  const submitAction = async (data, nocData = false, isOBPS = {}) => {
  
    setIsEnableLoader(true);
    if (typeof data?.customFunctionToExecute === "function") {
      data?.customFunctionToExecute({ ...data });
    }
    if (nocData !== false && nocMutation) {
      const nocPrmomises = nocData?.map(noc => {
        return nocMutation?.mutateAsync(noc)
      })
      try {
        setIsEnableLoader(true);
        const values = await Promise.all(nocPrmomises);
        values && values.map((ob) => {
          Digit.SessionStorage.del(ob?.Noc?.[0]?.nocType);
        })
      }
      catch (err) {
        setIsEnableLoader(false);
        let errorValue = err?.response?.data?.Errors?.[0]?.code ? t(err?.response?.data?.Errors?.[0]?.code) : err?.response?.data?.Errors?.[0]?.message || err;
        closeModal();
        setShowToast({ key: "error", error: { message: errorValue } });
        setTimeout(closeToast, 5000);
        return;
      }
    }
    if (mutate) {
      setIsEnableLoader(true);
      mutate(data, {
        onError: (error, variables) => {
          setIsEnableLoader(false);
          setShowToast({ key: "error", error });
          setTimeout(closeToast, 3000);
        },
        onSuccess: (data, variables) => {
          setIsEnableLoader(false);
          if (isOBPS?.bpa) {
            data.selectedAction = selectedAction;
            history.replace(`/digit-ui/employee/obps/response`, { data: data });
          }
          if (isOBPS?.isStakeholder) {
            data.selectedAction = selectedAction;
            history.push(`/digit-ui/employee/obps/stakeholder-response`, { data: data });
          }
          if (isOBPS?.isNoc) {
            history.push(`/digit-ui/employee/noc/response`, { data: data });
          }
          setShowToast({ key: "success", action: selectedAction });
          setTimeout(closeToast, 5000);
          queryClient.clear();
          queryClient.refetchQueries("APPLICATION_SEARCH");
        },
      });
      setIsEnableLoader(false);
    
    }
   
    // setOpenData(true);
    if(user?.info?.type === "EMPLOYEE"){
      setTimeout(() => {
        history.push({
          pathname: `/digit-ui/employee`,
        })
      }, 2000);
    }
    // else{
    //   setTimeout(() => {
    //     history.push({
    //       pathname: `/digit-ui/citizen/profile`,
    //     })
    //   }, 2000);
    // }
    
    
  closeModal();
  };

  const handleModal = () => {
    setOpenData(false);
    setTimeout(() => {
      history.push({
        pathname: `/digit-ui/employee`,
      })
    }, 2000);
  }

  if (isLoading || isEnableLoader) {
    return <Loader />;
  }
  console.log("applicationDetails123", applicationDetails, applicationData,showModal);
  return (
    <React.Fragment>
      {!isLoading ? (
        <React.Fragment>
         <ApplicationDetailsContentForm12
            applicationDetails={applicationDetails}
            workflowDetails={workflowDetails}
            isDataLoading={isDataLoading}
            isLoading={isLoading}
            edcrDetails={edcrDetails}
            collectionBillDetails={collectionBillDetails}
            applicationData={applicationData}
            businessService={businessService}
            timelineStatusPrefix={timelineStatusPrefix}
            statusAttribute={statusAttribute}
            paymentsList={paymentsList}
            showTimeLine={showTimeLine}
            onActionSelect={onActionSelect}
            setOnAddComments={setOnAddComments}
            forcedActionPrefix={forcedActionPrefix}
            submitAction={submitAction}
            actionData={workflowDetails?.data?.timeline}
            moduleCode={moduleCode}
            action={selectedAction}
            
          />
        </React.Fragment>
      ) : (
        <Loader />
      )}
          <Dialog open={opendata} onClose={handleModal} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description" >
          <DialogTitle id="alert-dialog-title" style={{textAlign:"center"}}>Form-12 Successfully File </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description" >
            <p><CheckCircleOutlineIcon  style={{ color: "green", variant: "filled" ,margin: "0px 40% 0",fontSize: "100px", padding: "2px"}} /></p>
              
              
              <p>
                {userRolesArray?.[0]?.code} Verification for {applicationDetails?.applicationType} ( Building Plan Approval) With Application no <span style={{ padding: "5px", color: "blue" }}>{applicationNumber}</span>  is Done Successfully.{" "}
                <span>
                  
                </span>
              </p>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleModal} autoFocus>
              Ok
            </Button>
          </DialogActions>
        </Dialog>
    </React.Fragment>
  );
};

export default ApplicationDetailsForm12;
